import { Component, Input, OnDestroy } from '@angular/core';
import { ApiService } from 'app/00_modules/core/services/api.service';
import { Observable, Subject } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';
import { NotificationService } from '../../../core/services/notification.service';
import { DownloadLinkAreaItem } from './DownloadLinkAreaItem';
import { DownloadLinkAreaFacade } from '../../../../store/facade/download-link-area.facade';
import { DeviceDetectorService } from '../../../device-detector/device-detector.service';
import { AsyncPipe } from '@angular/common';
import { IconComponent } from '../fa-icon/fa-icon.component';
import { OrderingFacade } from '../../../../store/facade/ordering.facade';

@Component({
    selector: 'je-download-link-area',
    templateUrl: './download-link-area.component.html',
    standalone: true,
    imports: [AsyncPipe, IconComponent],
})
export class DownloadLinkAreaComponent implements OnDestroy {
    private destroy$: Subject<boolean> = new Subject();
    private readonly customerAgreementDownloadPath = 'customer-agreement/content';
    public links$: Observable<DownloadLinkAreaItem[]>;

    public isMobile = false;
    public orderId = 0;

    @Input()
    public isMobileMenuOpen = false;

    constructor(
        private notificationService: NotificationService,
        private api: ApiService,
        private downloadLinkAreaFacade: DownloadLinkAreaFacade,
        private deviceService: DeviceDetectorService,
        private orderingFacade: OrderingFacade,
    ) {
        this.links$ = this.downloadLinkAreaFacade.downloadLinkAreaItems$.pipe(takeUntil(this.destroy$));
        this.isMobile = this.deviceService.isMobile() || this.deviceService.isTablet();
        this.orderingFacade.orderId$.pipe(takeUntil(this.destroy$)).subscribe(orderId => {
            this.orderId = orderId ?? 0;
        });
    }

    public ngOnDestroy(): void {
        this.destroy$.next(false);
        this.destroy$.unsubscribe();
    }

    public download(item: DownloadLinkAreaItem) {
        this.api
            .getDownload<Blob>(item.url, true, this.getFileName(item))
            .pipe(first(), takeUntil(this.destroy$))
            .subscribe({
                next: blob => {
                    if (Array.isArray(blob) && blob.length === 0) {
                        this.empty();
                    }
                },
                error: () => {
                    this.error();
                },
            });
    }

    private getFileName(item: DownloadLinkAreaItem): string | null {
        if (!item?.url?.includes(this.customerAgreementDownloadPath)) {
            return null;
        }

        if (this.orderId > 0) {
            return `Kundenstandard_${this.orderId}.pdf`;
        }

        return 'Kundenstandard.pdf';
    }

    private error(): Promise<any> {
        return this.notificationService.errorTranslate('DOWNLOAD_LINK_AREA.DOWNLOAD_FAILED_MESSAGE');
    }

    private empty(): Promise<any> {
        return this.notificationService.errorTranslate('DOWNLOAD_LINK_AREA.DOWNLOAD_EMPTY_MESSAGE');
    }
}
